import React from 'react';
import { formatValue } from './DataTableCard';

const ComparisonCard = ({ card }) => {
  if (!card || !card.items || card.items.length < 2) return null;

  const formats = card.metricFormats || {};
  const metricKeys = Object.keys(formats);

  const getWinner = (key) => {
    const values = card.items.map((item) => Number(item.metrics?.[key] || 0));
    const isLowerBetter = /cost|spend|harcama/i.test(key);
    if (isLowerBetter) {
      const min = Math.min(...values);
      return values.indexOf(min);
    }
    const max = Math.max(...values);
    return values.indexOf(max);
  };

  return (
    <div className="bg-white rounded-2xl border border-gray-200 p-4 shadow-sm w-full mt-3">
      {card.title && (
        <div className="text-xs font-semibold text-gray-700 mb-3">{card.title}</div>
      )}
      <div className="grid grid-cols-2 gap-4">
        {card.items.map((item, idx) => (
          <div key={idx} className="space-y-2">
            <div className="flex items-center gap-2 mb-2">
              {item.icon && (
                <img src={item.icon} alt="" className="w-5 h-5 object-contain" />
              )}
              <span className="text-[11px] font-semibold text-gray-600">{item.label}</span>
            </div>
            {metricKeys.map((key) => {
              const winner = getWinner(key);
              const isWinner = winner === idx;
              return (
                <div key={key} className="flex justify-between items-baseline">
                  <span className="text-[10px] text-gray-400 capitalize">
                    {key.replace(/_/g, ' ')}
                  </span>
                  <span className={`text-sm font-bold ${isWinner ? 'text-green-600' : ''}`}>
                    {formatValue(item.metrics?.[key], formats[key], key)}
                  </span>
                </div>
              );
            })}
          </div>
        ))}
      </div>
      {card.period && (
        <div className="mt-4 text-[10px] text-gray-400 text-right font-mono">
          {card.period.start} &rarr; {card.period.end}
        </div>
      )}
    </div>
  );
};

export default ComparisonCard;
